import { createContext, useReducer } from "react";

export const SocialResponsibilityContext = createContext();

export const socialResponsibilityReducer = (state, action) => {
    switch (action.type) {
        case 'SET_SOCIAL_RESPONSIBILITY':
            return {
                socialResponsibility: action.payload
            }
        case 'CREATE_SOCIAL_RESPONSIBILITY':
            return {
                socialResponsibility: [action.payload, ...state.socialResponsibility]
            }
        case 'DELETE_SOCIAL_RESPONSIBILITY':
            return {
                socialResponsibility: state.socialResponsibility.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const SocialResponsibilityContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(socialResponsibilityReducer, {
        socialResponsibility: null
    });

    return (
        <SocialResponsibilityContext.Provider value={{ ...state, dispatch }}>
            {children}
        </SocialResponsibilityContext.Provider>
    );
};